import UIToggle from 'UIComponents/input/UIToggle';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Toggle = ({
  id = '',
  label = '',
  value = false,
  disabled = false,
  disabledTooltipTitle = '',
  onChange = () => {},
  readOnly = false
}) => /*#__PURE__*/_jsxs(Flex, {
  alignItems: "center",
  justifyContent: "space-between",
  children: [/*#__PURE__*/_jsx(FormLabel, {
    htmlFor: id,
    paddingInlineEnd: "900",
    children: label
  }), /*#__PURE__*/_jsx(Box, {
    basis: "80px",
    paddingBlock: "400",
    paddingInlineStart: "600",
    children: /*#__PURE__*/_jsx(UITooltip, {
      title: disabledTooltipTitle,
      disabled: !disabled || !disabledTooltipTitle,
      children: /*#__PURE__*/_jsx(UIToggle, {
        "data-selenium": `form-${id}`,
        "data-checked": Boolean(value),
        id: id,
        size: "small",
        checked: Boolean(value),
        onChange: onChange,
        disabled: disabled,
        readOnly: readOnly
      })
    })
  })]
});
export default Toggle;